import React from 'react';
import ReactDOM from 'react-dom';

import { translations as thingTranslations } from '@digital/thing-ui';
import { translations as tsTranslations } from '@digital/ts-ui';
import { translations as uiTranslations } from '@digital/ui';
import { translations as gatewayTranslations } from '@gluon/ui';
import { translations as auditTranslations } from '@sms/plasma-audit-ui';
import { translations as securityTranslations } from '@sms/plasma-security-ui';
import { translations as uomTranslations } from '@sms/plasma-uom-ui';
import { BaseApp } from '@viridis/ui';

import logoAdmin from './assets/img/logo_admin.svg';
import logo from './assets/img/logo.svg';
import app from './config/app.json';
import appTranslations from './config/i18n';
import menu from './config/menu.json';
import pages from './pages';

import './assets/css/main.scss';

const translations = [
  appTranslations,
  securityTranslations,
  uomTranslations,
  auditTranslations,
  gatewayTranslations,
  thingTranslations,
  tsTranslations,
  uiTranslations,
];

function App() {
  return (
    <BaseApp
      code={app.code}
      title={window.location.pathname.startsWith('/admin') ? app.title : 'app.page.launchpad.viridisSuite'}
      logo={window.location.pathname.startsWith('/admin') ? logoAdmin : logo}
      translations={translations}
      userProfileRoutePath="/userProfile"
      menu={menu}
      pages={pages}
    />
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
